module.exports = __webpack_public_path__ + "static/no-time-for-silence-7e7254d8fc3abba038878495d5133d2c.png";